import { Input, typo } from '@cycle-app/ui';
import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const InputStyled = styled(Input)`
  width: 100%;
`;

export const Label = styled.h2`
  ${typo.body500};
  margin-bottom: 8px;
`;
